import React from 'react';
import PropTypes from 'prop-types';
import {useDroppable} from '@dnd-kit/core';
import {contentUtils, HTMLContent} from "mindsets-js-sdk";

import DnDDraggedItem from './DnDDraggedItem';


function DnDDroppableItem({item, selected, onRemove, component_data}) {
    const {isOver, setNodeRef} = useDroppable({
        id: item.dnd_id
    });

    function getItemStyle() {
        return {
            ...item.item_position
        }
    }

    function getDroppableStyle() {
        const style = {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minWidth: "72px",
            minHeight: "72px",
            padding: isOver ? "10px" : "10px",
            borderRadius: "4px",
            position: "relative",
            ..._.get(item, 'droppable_style')
        }

        const hide_box_when_filled = _.get(component_data, 'config.hide_box_when_filled');

        if (selected && hide_box_when_filled) {
            style.border = "none";
            style.background = "none";
        }

        return style;
    }

    function renderSelected() {
        if (!selected) {
            if (item.placeholder) {
                return (
                    <div>
                        <HTMLContent html_str={contentUtils.processStringContent(item.placeholder)}/>
                    </div>
                );
            } else {
                return undefined;
            }
        }

        return (
            <DnDDraggedItem
                item={selected}
                onRemove={onRemove(selected.dnd_id)}
                is_preview={false}
            />
        );
    }

    return (
        <div ref={setNodeRef} className="cc-dndpuzzle-layout-item" style={getItemStyle()}>
            <div style={getDroppableStyle()}>
                {renderSelected()}
            </div>
        </div>
    );
}

DnDDroppableItem.propTypes = {
    item: PropTypes.shape({
        dnd_id: PropTypes.string.isRequired,
        placeholder: PropTypes.string
    }).isRequired,
    component_data: PropTypes.object.isRequired,
    selected: PropTypes.object,
    onRemove: PropTypes.func.isRequired
}

export default DnDDroppableItem
